import React from 'react'
import loginPic from '../../assets/auth/login.png'
import logo from '../../assets/logo/brand-logo.png'
import { Button, Label, TextInput } from 'flowbite-react'
import { FcGoogle } from "react-icons/fc";
import { FaFacebook } from "react-icons/fa6";
import bg1 from '../../assets/auth/bg1.png'
import bg2 from '../../assets/auth/bg2.png'
import bg3 from '../../assets/auth/bg3.png'

function LoginIndex() {
    return (
        <>
            <div className='relative'>
                <div className='absolute bottom-0 -z-10'>
                    <img src={bg1} alt="bg1" />
                </div>
                <div className='absolute top-0 right-0'>
                    <img src={bg2} alt="bg2" />
                </div>
                <div className='absolute bottom-0 right-0'>
                    <img src={bg3} alt="bg3" />
                </div>
                <div className='px-[5%] xl:px-[8%] py-32 lg:py-16 h-screen'>
                    <div className='grid grid-cols-12 '>
                        <div className='col-span-12 lg:col-span-6 hidden lg:block'>
                            <img className='h-[480px] xl:h-[550px] 2xl:h-[600px] ' src={loginPic} alt="login form" />
                        </div>
                        <div className='col-span-12 lg:col-span-6 lg:px-20'>
                            <div className='flex items-center mb-5'>
                                <img className='-ml-5' src={logo} alt="" />
                                <h3 className='text-xl lg:text-2xl xl:text-4xl font-bold'>Login</h3>
                            </div>
                            <div>
                                <form className="flex max-w-md flex-col gap-4">
                                    <div className='mb-1 xl:mb-3'>
                                        <div className="mb-5 lg:mb-1 xl:mb-3 block">
                                            <Label className='lg:text-sm xl:text-base' htmlFor="email1" value="Email or Phone Number" />
                                        </div>
                                        <TextInput id="email1" type="email" placeholder="Email or Phone Number" required />
                                    </div>
                                    <div className='mb-1 xl:mb-3'>
                                        <div className="mb-5 lg:mb-1 xl:mb-3 block">
                                            <Label className='lg:text-sm xl:text-base' htmlFor="password1" value="Password" />
                                        </div>
                                        <TextInput id="password1" type="password" placeholder="Password" required />
                                        <p className='mt-5 lg:mt-2 text-fontColor3 text-sm'>Forgot Password?</p>
                                    </div>
                                    <Button className='bg-background2 rounded-3xl' type="submit">Login</Button>
                                </form>
                            </div>
                            <div className='mt-8 lg:mt-1 xl:mt-3 2xl:mt-5'>
                                <p className='text-center text-sm xl:text-base'>or continue with</p>
                                <div className='flex justify-around gap-5 my-6 lg:my-5'>
                                    <div className='border-2 lg:px-10 xl:px-14 lg:py-1 xl:py-2 rounded-full'><FcGoogle size={30} /></div>
                                    <div className='border-2 lg:px-10 xl:px-14 lg:py-1 xl:py-2 rounded-full'><FaFacebook size={30} /></div>
                                </div>
                                <p className='text-center text-fontColor3 text-sm xl:text-base'>Don't have an account yet?
                                    <span className='text-base text-primary-light font-semibold ms-3 underline'>Sign up</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LoginIndex
